import { defineMessages } from 'react-intl';

export default defineMessages({
  tryPeriodFinishTittle: {
    id: 'cboard.components.PremiumFeature.tryPeriodFinishTittle',
    defaultMessage: 'Your free trial has ended'
  },
  featureBlockedTittle: {
    id: 'cboard.components.PremiumFeature.featureBlockedTittle',
    defaultMessage: 'This feature is blocked'
  },
  upgradeNow: {
    id: 'cboard.components.PremiumFeature.upgradeNow',
    defaultMessage: 'Upgrade now'
  },
  unlockBoardText: {
    id: 'cboard.components.PremiumFeature.unlockBoardText',
    defaultMessage:
      'Consider subscribing to support Cboard development and unlock premium features like public boards, online voices, advanced editing tools, and more!'
  }
});
